import { Button } from '@augmentt-dev/ui-components'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { Toast } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import styles from './CopyButton.module.scss'

const propTypes = {
  /**
   * Content of the button
   */
  label: PropTypes.node,
  /**
   * Text to be copied
   */
  textToCopy: PropTypes.string.isRequired,
  /**
   * Class to override default styles
   */
  className: PropTypes.string,
  /**
   * Id of the button
   */
  id: PropTypes.string,
}

function CopyButton(props) {
  const { label = null, textToCopy, className = '', id = undefined } = props ?? {}

  const [showToast, setShowToast] = useState(false)

  return (
    <div className={clsx(styles.wrapper, className)}>
      <Toast autohide show={showToast} onClose={() => setShowToast(false)} delay={1000} className={styles.toast}>
        <FormattedMessage id="GENERAL.COPIED" />
      </Toast>
      <Button
        id={id}
        variant="link"
        className="p-0"
        onClick={() => navigator.clipboard.writeText(textToCopy).then(() => setShowToast(true))}
      >
        {label}
        <i className={clsx('far fa-copy', label && 'ms-2')} />
      </Button>
    </div>
  )
}

CopyButton.propTypes = propTypes

export default CopyButton
